/**
 * @file Input component for phone input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputStringBase } from '../../../base/helpers/input-string-base';
/**
 * Class for the phone input component
 */
var InputPhoneComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputPhoneComponent, _super);
    function InputPhoneComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Holds the displayed value which includes the mask.
         * @private
         */
        _this._displayValue = '';
        /**
         * The input mask for phone numbers.
         * @type {*}
         */
        _this.mask = ['+', /[1-9]+/, /[0-9]/, ' ',
            /[1-9]/, /[0-9 ]/, /[0-9 ]/,
            /[0-9 ]/, /[0-9 ]/, /[0-9 ]/,
            /[0-9 ]/, /[0-9 ]/, /[0-9 ]/,
            /[0-9 ]/, /[0-9 ]/, /[0-9 ]/];
        return _this;
    }
    Object.defineProperty(InputPhoneComponent.prototype, "displayValue", {
        /**
         * Gets the displayed value which includes the mask.
         * @type {string}
         */
        get: function () {
            var masked = this.convertValueToDisplayValue();
            if (masked !== this._displayValue) {
                // Synchronize display value with binded value
                this._displayValue = masked;
            }
            return this._displayValue;
        },
        /**
         * Sets the displayed value which includes the mask.
         */
        set: function (newValue) {
            // Synchronize binded value with display value
            this.value = this.parseValue(newValue);
            // Setting the display value.
            this._displayValue = newValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Converts the display value to binded value format.
     * The input mask is stripped from the binded value.
     * @protected
     * @param {*} newValue The display value which includes the input mask.
     * @returns {*} The binded value lacking the input mask.
     */
    InputPhoneComponent.prototype.parseValue = function (newValue) {
        var parsed = newValue.replace(/ /g, '#');
        parsed = parsed.replace(/_/g, ' ').trimRight();
        parsed = parsed.replace(/#/g, ' ');
        if (parsed.length === 4) {
            parsed = parsed.trimRight();
        }
        return parsed;
    };
    /**
     * Converts the binded value to the display value which includes the input mask.
     * @private
     * @returns {string} The display value which includes the input mask.
     */
    InputPhoneComponent.prototype.convertValueToDisplayValue = function () {
        var masked = this.value + '';
        if (masked.length === 0) {
            return masked;
        }
        while (masked.length < 16) {
            if (masked.length === 3) {
                masked += ' ';
            }
            else {
                masked += '_';
            }
        }
        return masked;
    };
    return InputPhoneComponent;
}(InputStringBase));
export { InputPhoneComponent };
